<template>
    <div class="card_meta" @click="details()" :class="Mousetime ? 'card_shadow' : ''" @mouseover="handleMouseOver"
        @mouseleave="handleMouseLeave">
        <img class="imgbox" v-lazy="propsone.imgurl" :key='propsone.imgurl' alt="">
        <!-- <video autoplay loop muted class="videobox" v-if="autoplayblen">
            <source :src="propsone.videourl" type="video/mp4">
        </video> -->
        <video autoplay loop muted class="videobox" @error='videoOnerror' @load="videoOnload" :data-gid="propsone.id"
            :data-gname="propsone.gamename" :src="propsone.videourl" v-if="autoplayblen" type="video/mp4">
            <!-- <source @error='videoOnerror' src="//xxx/default.jpg"  @load="videoOnload" > -->
        </video>
        <div class="bottom_title">
            <div class="card_title">{{ propsone.gamename }}</div>
            <div class="card_btn"></div>
        </div>
    </div>
</template>
<script setup lang="ts">
const autoplayblen = ref(false)
import { ref, defineProps, watch, inject } from 'vue'
import { useRouter, useRoute } from 'vue-router'
const router = useRouter()
const route = useRoute()
const videoOnerror = () => {
    console.log('视频加载失败', propsone.gamename);
}
const propsone = defineProps({
    videourl: {
        type: String,
    },
    imgurl: {
        type: String,
    },
    id: {
        type: [Number, String],
    },
    gamename: {
        type: String,
    }
})
import { logEventAnalytics } from '@/Firebase/firebase';
let type: any = inject('sceneType')
const details = () => {
    logEventAnalytics("c_game", {
        gid: propsone.id,
        type: type.value,
    })
    router.push({ path: `/GameDetails/${propsone.id}`, params: propsone.id })
    console.log(propsone.id, type.value, '场景判断值');
}
const Mousetime = ref(false)
const timenum = ref<any>(0)
// 创建计时器
const createTimer = (interval: any, onTick: any) => {
    let timerId = null;
    function start() {
        if (timerId !== null) {
            // 如果计时器已经启动，则不执行任何操作
            return;
        }
        timerId = setInterval(onTick, interval);
    }
    function stop() {
        if (timerId !== null) {
            clearInterval(timerId);
            timerId = null;
        }
    }
    return {
        start: start,
        stop: stop
    };
}
const timer = createTimer(1000, () => {
    // 每隔1秒执行一次 悬停三秒触发蒙层
    timenum.value++
    if (timenum.value == 1) {
        Mousetime.value = true
    }
})
const handleMouseOver = () => {
    // 处理移入事件
    autoplayblen.value = true
    // 启动计时器 
    timer.start()
    console.log('移入');
}
const handleMouseLeave = () => {
    timer.stop()
    autoplayblen.value = false
    Mousetime.value = false
    timenum.value = 0
    // 处理移出事件
}
// console.log(propsone.imgurl, propsone.videourl);
</script>
<style lang="less" scoped>
// .card_shadow {
//     box-shadow: 0px 0px 20px 2000px rgba(0, 0, 0, .8) !important;
//     z-index: 100;
// }
.card_meta {
    width: 100%;
    height: 100%;
    border-radius: 5px;
    position: relative;
    cursor: pointer;
    // border: 2px solid transparent;
    // box-shadow:
    overflow: hidden;
    box-sizing: border-box;
    background: rgb(55, 57, 82);
    transition: all 0.2s ease;
    border-radius: 10px;
    background-clip: padding-box;

    //   box-shadow: 0px 0px 20px 2000px rgba(0, 0, 0, .8) !important;
    .imgbox {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        background: rgba(255, 255, 255, 0.1);

    }

    .videobox {
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        // will-change: opacity;
        // transition: opacity 0.6s cubic-bezier(0.5, 0, 0.1, 1) 0ms;
    }

    .bottom_title {
        width: 100%;
        height: 40px;
        color: white;
        background: rgba(0, 0, 0, 0.7);


        position: absolute;
        bottom: -40px;
        transition-duration: 0.3s;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        padding-left: 9px;
        padding-right: 9px;

        .card_title {
            min-width: 91px;
            height: 23px;
            font-size: 12px;
            font-weight: 800;
            display: flex;
            // justify-content: center;
            align-items: center;
            flex-wrap: nowrap;
        }

        .card_btn:hover {
            opacity: 0.8;
        }
    }
}

.card_meta:active {
    transform: scale(0.9);
}

.card_meta:hover .bottom_title {
    bottom: 0px;
}

.card_meta:hover {
    box-shadow: 0px 0px 0px 2px #5142FC, ;
}
</style>